import { CalmBlock, CalmDetails, CalmItem } from '../components/CalmMotion'
import { SalesConversionCard } from '../components/SalesConversionCard'
import { useT } from '../i18n/t'
import { publicCopyKey } from '../lib/productFlags'

const faqIds = ['1', '2', '3', '4', '5'] as const

export function FaqSection({ calm }: { calm?: boolean } = {}) {
  const { t } = useT()

  return (
    <section
      id="faq"
      className="container-x scroll-mt-28 py-14 md:py-20"
    >
      <CalmBlock calm={calm} className="content">
        <CalmItem calm={calm}>
          <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-ink/55 md:text-[13px]">
            {t('landing.faq.eyebrow')}
          </p>
          <h2 className="display mt-2 text-[26px] font-bold leading-[1.1] text-ink md:text-[40px]">
            {t('landing.faq.title')}
          </h2>
          <p className="mt-3 text-[15px] font-medium text-ink/60 md:text-base">
            {t('landing.faq.subtitle')}
          </p>
        </CalmItem>

        <div className="mt-8 divide-y divide-ink/10 border-y border-ink/10 md:mt-10">
          {faqIds.map((id) => (
            <CalmDetails key={id} calm={calm} className="group py-5 md:py-6">
              <summary className="flex cursor-pointer list-none select-none items-start justify-between gap-6 text-[16px] font-normal text-ink transition focus:outline-none focus-visible:underline md:text-[18px]">
                <span>{t(`landing.faq.q${id}`)}</span>
                <span
                  aria-hidden="true"
                  className="mt-0.5 shrink-0 text-2xl font-light leading-none text-ink/50 transition-transform duration-200 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <p className="mt-3 max-w-[60ch] text-[14px] font-normal leading-relaxed text-ink/60 md:text-[15px]">
                {t(id === '4' ? publicCopyKey('landing.faq.a4', 'landing.faq.a4MiniOnly') : `landing.faq.a${id}`)}
              </p>
            </CalmDetails>
          ))}
        </div>

        <SalesConversionCard className="mt-10 md:mt-14" />
      </CalmBlock>
    </section>
  )
}
